import Interactive from './script/Interactive';

new Interactive();
